























































































import Vue from "vue";
export default Vue.extend({
  data: () => ({
    showFinishedDialog: false,
  }),
  methods: {
    finish() {
      this.showFinishedDialog = true;
    },
    goToStep(stepNumber: number) {
      this.$emit("goToStep", stepNumber);
    },
  },
});
